import { gql } from '@apollo/client';
import TENANT_SUPPLIER from 'api/fragments/TENANT_SUPPLIER';
const GET_SUPPLIER = gql `
  ${TENANT_SUPPLIER}
  query GetSupplier($id: ID!) {
    node(id: $id) {
      ... on SupplierNode {
        ...TenantSupplierFragment
      }
    }
  }
`;
export default GET_SUPPLIER;
